import { motion } from 'framer-motion';
import { reviews } from '@/data/reviews';
import { company } from '@/data/company';
import { Star, ArrowRight, QuoteLeft, Facebook } from '@/components/ui/Icons';

export function Reviews() {
  return (
    <section className="bg-paper-50">
      <div className="container-page py-20 sm:py-24">
        <header className="mx-auto mb-12 max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold-700">Reviews</p>
          <h2 className="mt-3 font-display text-4xl font-semibold leading-[1.05] text-navy-900 sm:text-5xl/none">
            Recommended by the people we’ve worked with
          </h2>
          <div className="mt-5 flex items-center justify-center gap-1.5 text-gold-500">
            {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-4 w-4" />)}
            <span className="ml-2 text-sm font-semibold text-navy-800">5.0</span>
            <span className="text-sm text-ink-700">· verified Facebook reviews</span>
          </div>
        </header>

        <ul className="grid gap-6 lg:grid-cols-3">
          {reviews.map((r, i) => (
            <motion.li
              key={r.author}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: 0.08 * i, ease: [0.22, 1, 0.36, 1] }}
              className="group relative flex flex-col rounded-2xl border border-paper-100 bg-paper-0 p-7 shadow-card transition hover:-translate-y-1 hover:border-gold-300/70 hover:shadow-[0_24px_48px_-24px_rgba(7,15,31,0.4)]"
            >
              <QuoteLeft className="absolute right-6 top-6 h-6 w-6 text-gold-300/50" />

              <div className="flex items-center gap-4">
                <img
                  src={r.avatar}
                  alt={r.author}
                  loading="lazy"
                  className="h-12 w-12 rounded-full object-cover ring-2 ring-gold-300/40"
                />
                <div>
                  <p className="font-semibold text-navy-900">{r.author}</p>
                  <p className="flex items-center gap-1.5 text-xs text-ink-700">
                    <Facebook className="h-3 w-3 text-[#1877F2]" />
                    Recommends on {r.source}
                  </p>
                </div>
              </div>

              <div className="mt-3 flex gap-0.5 text-gold-500">
                {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-3.5 w-3.5" />)}
              </div>

              <p className="mt-4 text-[15px] leading-relaxed text-ink-700">
                {r.body.length > 280 ? r.body.slice(0, 280).trim() + '…' : r.body}
              </p>
            </motion.li>
          ))}
        </ul>

        <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href={company.google.reviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold group"
          >
            Leave a review
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <a
            href={company.socials.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-navy-800 underline-offset-4 hover:text-gold-700 hover:underline"
          >
            See more on Facebook →
          </a>
        </div>
      </div>
    </section>
  );
}
